module.exports = __webpack_public_path__ + "img/icon.6660623b.png";